import React from 'react';
import { Page } from 'components';
import { ShipmentProvider } from './ShipmentContext';
import Shipment from './Shipment';


let Index = () => {
    return (
        <ShipmentProvider>
            <Page title="Shipment">
                <Shipment />
            </Page>
        </ShipmentProvider>
    );
}

export default Index;